export default __webpack_public_path__ + "static/media/dataLeakageRealcase.2921df22.jpg";